import { render, staticRenderFns } from "./zxToStudy.vue?vue&type=template&id=f2f51a20&scoped=true&"
import script from "./zxToStudy.vue?vue&type=script&lang=js&"
export * from "./zxToStudy.vue?vue&type=script&lang=js&"
import style0 from "./zxToStudy.vue?vue&type=style&index=0&id=f2f51a20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f51a20",
  null
  
)

export default component.exports